/**
 * Initialize and handle an custom select box
 * @type {CustomSelect}
 */
export class CustomSelect {
    constructor() {
        // find all custom selects
        this.selectWrappers = document.querySelectorAll('.js__custom-select')
        // and build the custom select
        for (let wrapper of this.selectWrappers) {
            this.buildCustomSelect(wrapper)
        }
    }

    buildCustomSelect(filterWrapper) {
        const _this = this
        const $originSelect = filterWrapper.querySelector('select')
        const $customSelect = filterWrapper.querySelector('.custom-select__options')
        const $customSelectItems = $customSelect.querySelectorAll('li')
        const $selectedPreview = filterWrapper.querySelector('.custom-select__preview')

        // hide all other open custom selects and toggle this current
        $selectedPreview.addEventListener('click', function (e) {
            e.stopPropagation()
            // toggle this custom select
            for (let active of document.querySelectorAll('.custom-select.active')) {
                // do not affect this clicked selector
                if (active === filterWrapper) continue
                active.classList.remove('active')
            }
            filterWrapper.classList.toggle('active')
        })

        for (let listItem of $customSelectItems) {
            listItem.addEventListener('click', function (e) {
                e.stopPropagation()
                // get clicked text/rel to filter box
                let chosenText = this.innerHTML
                let chosenValue = this.getAttribute('rel')
                if (chosenValue === 'reset') {
                    // set clicked text/rel to initial placeholder
                    $selectedPreview.innerHTML = this.dataset.selectPlaceholder
                    // set value of origin select
                    $originSelect.value = ''
                } else {
                    // set clicked text/rel to filter box
                    $selectedPreview.innerHTML = chosenText
                    // set value of origin select
                    $originSelect.value = chosenValue
                }
                // close the list
                filterWrapper.classList.remove('active')
                // update available items within the custom select
                _this.updateCustomSelect(this, $customSelectItems)
                // Create a new 'change' event to dispatch on origin select
                let event = new Event('change')
                $originSelect.dispatchEvent(event)
            })
        }

        // hide open selected if there is clicked outside of an custom select
        document.addEventListener('click', function () {
            filterWrapper.classList.remove('active')
        })
    }

    // hide selected item from selection list, show other
    updateCustomSelect(selected, list) {
        for (let item of list) {
            if (item === selected) {
                item.classList.add('hidden')
            } else {
                item.classList.remove('hidden')
            }
        }
    }
}
